// ProtectedRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({
    isAllowed,
    redirectPath = "/login",
    children,
}) => {
    console.log("ProtectedRoute - isAllowed:", isAllowed);
    console.log("ProtectedRoute - token:", localStorage.getItem("token"));
    const token = localStorage.getItem("token");
    if (!isAllowed && !token) {
        return <Navigate to={redirectPath} replace />;
    }

    return children ? children : <Outlet />;
};

export default ProtectedRoute;